import {
  DownloadBtn,
  MalwareStatus
} from "../../util/constants";
import { Button } from "../CommonUIComponents/Button/Button";
import { DownloadIcon } from "../../icons";
import { saveAs } from "file-saver";
import { downloadFileFromBlod } from "../../store/services/engagement.service";

export function customCellRenderer({ node }) {
  async function onDownloadClickHandler(node) {
    try {
      let request = {
        fileName: node.data.fileName,
        moduleName: "DecarbActivityData/Module1",
      };
      const data = await downloadFileFromBlod({ request });

      const blob = new Blob([data.data], {
        type: data.headers["content-type"],
      });

      saveAs(blob, node.data.fileName, {
        "content-type": data.headers["content-type"],
      });
    } catch (error) {
      console.error("Error in downloading file", error);
    }
  }

  return node.data.dataValidation_Status === MalwareStatus ? ( 
      <></>
  ) : (<Button
          onClick={(e) => {
            onDownloadClickHandler(node);
          }}
          variant="text"
          className={"donwload-archived-file-button"}
        >
          <DownloadIcon />
          <span>{DownloadBtn}</span>
        </Button>);
}
